import React from "react";
import Header from "../../../Header";
import Footer from "../../../Footer";
import AccordionTitle from "./AccordionTitle";
import AccordionContent from "./AccordionContent";

const Accordion = () => {
	return (
		<>
			<Header />
			<AccordionTitle />
			<AccordionContent />
			<Footer />
		</>
	);
};
export default Accordion;
